module.exports = __webpack_public_path__ + "static/img/hipotecalo.a5be2645.svg";